import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Button from "@/components/common/button/Button";
import styles from "./BackButton.module.css";

interface BackButtonProps {
    to: string;
}

const BackButton: React.FC<BackButtonProps> = ({ to }) => {
    const navigate = useNavigate();

    return (
        <Button
            variant="secondary"
            className={styles["back-btn"]}
            onClick={() => navigate(to)}
            leftIcon={<ArrowLeft size={16} />}
        >
            Volver
        </Button>
    );
};

export default BackButton;
